(function () {
  function initMarquee(slider) {
    if (!slider || slider.dataset.marqueeInit === "1") return;
    slider.dataset.marqueeInit = "1";

    const ul = slider.querySelector("ul");
    if (!ul) return;

    // ✅ Evita duplicar si el liquid ya duplicó contenido
    // Si quieres que el JS sea el único que duplica, quita el duplicado del liquid.
    if (ul.children.length > 0 && !ul.dataset.tripled) {
      // Triplica UNA sola vez (no infinito de duplicaciones)
      ul.innerHTML = ul.innerHTML + ul.innerHTML + ul.innerHTML;
      ul.dataset.tripled = "1";
    }

    // Centrar para scroll en ambas direcciones
    setTimeout(() => {
      slider.scrollLeft = ul.scrollWidth / 3;
    }, 50);

    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let isPaused = false;

    let velocity = 0;
    let animationFrame = null;
    let lastMove = 0;
    let lastTime = 0;

    const onDown = (pageX) => {
      isDragging = true;
      startX = pageX - slider.offsetLeft;
      startScrollLeft = slider.scrollLeft;
      slider.style.cursor = "grabbing";
      velocity = 0;
      if (animationFrame) cancelAnimationFrame(animationFrame);
      lastMove = pageX;
      lastTime = Date.now();
    };

    const onMove = (pageX) => {
      if (!isDragging) return;

      const now = Date.now();
      const x = pageX - slider.offsetLeft;
      const dx = x - startX;
      slider.scrollLeft = startScrollLeft - dx;

      velocity = (pageX - lastMove) / (now - lastTime + 1);
      lastMove = pageX;
      lastTime = now;
    };

    const onUp = () => {
      if (!isDragging) return;
      isDragging = false;
      slider.style.cursor = "grab";

      // Inercia
      const momentum = () => {
        if (Math.abs(velocity) < 0.05) return;
        slider.scrollLeft -= velocity * 18; // factor para que se sienta bien
        velocity *= 0.95; // fricción real
        animationFrame = requestAnimationFrame(momentum);
      };
      momentum();
    };

    // Mouse
    slider.addEventListener("mousedown", (e) => onDown(e.pageX));
    slider.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      e.preventDefault();
      onMove(e.pageX);
    });
    slider.addEventListener("mouseup", onUp);
    slider.addEventListener("mouseleave", () => {
      isPaused = false;
      onUp();
      slider.style.cursor = "grab";
    });

    // Touch
    slider.addEventListener(
      "touchstart",
      (e) => onDown(e.touches[0].pageX),
      { passive: true }
    );
    slider.addEventListener(
      "touchmove",
      (e) => onMove(e.touches[0].pageX),
      { passive: true }
    );
    slider.addEventListener("touchend", onUp);

    // Pause on hover
    slider.addEventListener("mouseenter", () => (isPaused = true));
    slider.addEventListener("mouseleave", () => (isPaused = false));

    // Auto-scroll infinito
    function autoScroll() {
      if (!isPaused && !isDragging) {
        slider.scrollLeft += 1;

        const third = ul.scrollWidth / 3;
        if (slider.scrollLeft >= third * 2) slider.scrollLeft = third;
        if (slider.scrollLeft <= 0) slider.scrollLeft = third;
      }
      slider._marqueeTimer = setTimeout(autoScroll, 30);
    }

    autoScroll();
  }

  function initAll() {
    // ✅ soporta #slider (viejo) y sliders con id="slider-{{ section.id }}"
    document.querySelectorAll('.slider-wrapper[id="slider"], .slider-wrapper[id^="slider-"]').forEach(initMarquee);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  // Shopify Theme Editor
  document.addEventListener("shopify:section:load", (e) => {
    if (!e.target) return;
    e.target
      .querySelectorAll('.slider-wrapper[id="slider"], .slider-wrapper[id^="slider-"]')
      .forEach(initMarquee);
  });
})();
